"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailItemImage = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DetailItemImage = ({
  detailItem: {
    images,
    mediaType
  }
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.DETAIL_ITEM_IMAGE),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Image, {
      alt: mediaType.toLocaleLowerCase(),
      src: images.normal
    })
  });
};
exports.DetailItemImage = DetailItemImage;
